import { Badge, ContextMenu } from "../../../../elements";
import { useNavbar } from "../../hooks";
import { NavbarLinksItem } from "../navbar-links-item.component";

import styles from "./navbar-links-desktop.module.css";

export function NavbarLinksDesktop() {
  const { guestLinks, shouldOpenInSameWindow } = useNavbar();
  const linkTarget = shouldOpenInSameWindow ? undefined : "_blank";

  return (
    <div className={`${styles.Menu} VisibleTablet VisibleDesktop`}>
      {guestLinks
        .filter(({ label }) => label !== "Ajuda")
        .map(({ dataQA, label, links, isNew }) => (
          <div data-qa={dataQA} key={label} className={styles.MenuItem}>
            <ContextMenu>
              <ContextMenu.Button>
                <div role="menu" className={styles.IsNewWrapper}>
                  <NavbarLinksItem role="menuitem">{label}</NavbarLinksItem>
                  {isNew && (
                    <Badge
                      isOutlined
                      text="NOVO"
                      size="small"
                      variant="primary"
                      className={styles.Badge}
                    />
                  )}
                </div>
              </ContextMenu.Button>
              <ContextMenu.Content role="menu" aria-label={label}>
                {links.map((link) => (
                  <ContextMenu.Item
                    key={link.label}
                    data-qa={link.dataQA}
                    href={link.href}
                    target={linkTarget}
                    as="a"
                  >
                    <span className={styles.IsNewWrapper}>
                      {link.label}
                      {link.isNew && (
                        <Badge
                          isOutlined
                          text="NOVO"
                          size="small"
                          variant="primary"
                          className={styles.Badge}
                        />
                      )}
                    </span>
                  </ContextMenu.Item>
                ))}
              </ContextMenu.Content>
            </ContextMenu>
          </div>
        ))}
    </div>
  );
}
